// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"570":"00add688","615":"88ab02bc","787":"9a0867cf"}[chunkId] + ".chunk.js";
};